import 'antd/lib/select/style'
import './select.less'

export * from 'antd/lib/select'

import { Select, SelectProps } from './select'

export { SelectProps }
export default Select
